export interface JobSearchRequest {
  ids: number[]
  registeredDateFrom: string
  registeredDateTo: string
  group: string
  note: string
}

export function JobSearchRequestToJSON(value: JobSearchRequest): any {
  return {
    ids: value.ids && value.ids.length !== 0 ? value.ids : undefined,
    registered_date_from:
      value.registeredDateFrom !== '' ? value.registeredDateFrom : undefined,
    registered_date_to:
      value.registeredDateTo !== '' ? value.registeredDateTo : undefined,
    group: value.group !== '' ? value.group : undefined,
    note: value.note !== '' ? value.note : undefined
  }
}

export const defaultJobSearchRequest = (): JobSearchRequest => ({
  ids: [],
  registeredDateFrom: '',
  registeredDateTo: '',
  group: '',
  note: ''
})
